import { z } from 'zod';

export const zBrandSpecialUserSegmentIds = z
  .union([z.number(), z.array(z.number())])
  .nullable()
  .optional();
